import { PickUp } from "../../../models";

export const getPickup = (data: any): PickUp => {
  return {
    id: data.id,
    address: data.attributes.address,
    zip: data.attributes.zip,
    service: data.attributes.service,
    dumpsterSize: data.attributes.dumpster_size,
    pickupDate: data.attributes.pickup_date,
    status: data.attributes.status,
    orderId: data.attributes.order_id,
    driverId: data.attributes.driver_id,
    name: data.attributes.name,
    instructions: data.attributes.instructions,
    materialDisposing: data.attributes.material_disposing,
    latitude: data.attributes.latitude,
    longitude: data.attributes.longitude,
    priority: data.attributes.priority,
    city: data.attributes.city || "",
  };
};

export const getPickups = (data: any): PickUp[] => {
  return data.map(getPickup);
};
